import React, { useContext, useEffect } from 'react';

import CartEventsContext from '../../../common/contexts/CartEventsContext';
import FeaturesContext from '../../../common/contexts/FeaturesContext';
import LocResourcesContext from '../../../common/contexts/LocResourcesContext';

import ArticleHighlighted from './ArticleHighlighted';

interface ArticlesHighlightedCarouselProps {
  view: string;
}
const ArticlesHighlightedList = ({
  view
}: ArticlesHighlightedCarouselProps) => {
  const GLOBAL_PREFIX = 'loy-bp-rws-articles-highlighted';
  const { articlesHighlighted } = useContext(CartEventsContext);
  const { features } = useContext(FeaturesContext);
  const { onFormatLocale } = useContext(LocResourcesContext);

  useEffect(() => {
    const articles = document.getElementsByClassName(GLOBAL_PREFIX)[0];
    if (articles) {
      const articlesList = articles.getElementsByClassName(GLOBAL_PREFIX + '__articles')[0];
      const articlesListFirstChild = articlesList
        ? articlesList.getElementsByTagName('li')[0]
        : null;
      const setWhiteGradientLeft = () => {
        if (articlesListFirstChild && articlesListFirstChild.getBoundingClientRect().left > 0) {
          articles.classList.add('is-reset');
        } else {
          articles.classList.remove('is-reset');
        }
      };
      articles.addEventListener('touchend', setWhiteGradientLeft);
      return function cleanUp() {
        articles.removeEventListener('touchend', setWhiteGradientLeft);
      };
    }
    return () => {};
  }, []);

  return (
    articlesHighlighted &&
    articlesHighlighted.length > 0 &&
    features.articlesHighlighted && (
      <React.Fragment>
        <div className={`${GLOBAL_PREFIX}__list`}>
          <div className={`${GLOBAL_PREFIX}__title`}>
            {onFormatLocale?.('loy.rewards.shop.promotions.title')}
          </div>
          <div className={`${GLOBAL_PREFIX}__subtitle`}>
            {onFormatLocale?.('loy.rewards.shop.promotions.subtitle')}
          </div>
          <div className={`${GLOBAL_PREFIX} is-reset`}>
            <ul className={`${GLOBAL_PREFIX}__articles`}>
              {articlesHighlighted.map((article) => {
                return (
                  <ArticleHighlighted
                    article={article}
                    view={view}
                    key={article.shopIdentifier}
                  />
                );
              })}
            </ul>
          </div>
        </div>
      </React.Fragment>
    )
  );
};

export default ArticlesHighlightedList;
